import { browser } from '$app/environment';
import { init, register, locale, getLocaleFromNavigator } from 'svelte-i18n';

export const defaultLocale = 'en';
export const supportedLocales = [
	'en',
	'sv-SE',
	'fr-FR',
	'es-ES',
	'de-DE',
	'ja-JP',
	'zh-CN',
	'it-IT',
	'ko-KR',
	'pt-BR',
	'vi-VN',
	'pl-PL',
	'nl-NL',
	'nb-NO',
	'da-DK',
	'fi-FI',
	'uk-UA'
];

// Register all supported locales
register('en', () => import('./locales/en.json'));
register('sv-SE', () => import('./locales/sv-SE.json'));
register('fr-FR', () => import('./locales/fr-FR.json'));
register('es-ES', () => import('./locales/es-ES.json'));
register('de-DE', () => import('./locales/de-DE.json'));
register('ja-JP', () => import('./locales/ja-JP.json'));
register('zh-CN', () => import('./locales/zh-CN.json'));
register('it-IT', () => import('./locales/it-IT.json'));
register('ko-KR', () => import('./locales/ko-KR.json'));
register('pt-BR', () => import('./locales/pt-BR.json'));
register('vi-VN', () => import('./locales/vi-VN.json'));
register('pl-PL', () => import('./locales/pl-PL.json'));
register('nl-NL', () => import('./locales/nl-NL.json'));
register('nb-NO', () => import('./locales/nb-NO.json'));
register('da-DK', () => import('./locales/da-DK.json'));
register('fi-FI', () => import('./locales/fi-FI.json'));
register('uk-UA', () => import('./locales/uk-UA.json'));

// Initialize i18n with default configuration
init({
	fallbackLocale: defaultLocale,
	initialLocale: defaultLocale,
});

// Save locale changes to localStorage when on client
if (browser) {
	locale.subscribe((value) => {
		if (value) {
			localStorage.setItem('locale', value);
			// Also save as cookie for server-side persistence
			document.cookie = `locale=${value};path=/;max-age=31536000;samesite=lax`;
		}
	});
}